<template>    
    <iframe
        :src="url"
        allow="local-network-access https://app-qa.betrsign.com https://app-test.betrsign.com https://app.betrsign.com"
    ></iframe>
</template>

<script setup lang="ts">        
    let props = defineProps({
        url: {
            type: String,
            required: true
        }
    })
</script>